import { FaIcon } from '@atoms/icons';
import { ContainedIconButton } from '@atoms/buttons';

import { Box, CircularProgress, Stack, Tooltip, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';

type RefreshButtonProps = {
  localizationSubset: string;
  lastUpdate: dayjs.Dayjs | null;
  onRefresh: () => void;
  intervalMs?: number; // milliseconds
  refreshIntervalMs?: number; // milliseconds
};

let interval: number;
export const HeaderRefreshButton = ({
  localizationSubset,
  lastUpdate,
  onRefresh,
  intervalMs = 1000,
  refreshIntervalMs = 15000,
}: RefreshButtonProps) => {
  const theme = useTheme();
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    clearInterval(interval);
    interval = +setInterval(() => {
      if (lastUpdate) {
        const now = dayjs();
        const diff = now.diff(lastUpdate, 'milliseconds');
        const total = refreshIntervalMs;
        const percentage = ((total - diff) / total) * 100;
        setPercentage(100 - percentage);
        if (percentage > 100 || percentage < 0) {
          setPercentage(0);
        }
      }
    }, intervalMs);
  }, [lastUpdate]);

  const handleClick = () => {
    onRefresh && onRefresh();
  };

  return (
    <Stack direction={'row'} sx={{ width: '100%' }} spacing={1}>
      <Tooltip
        title={
          <FormattedMessage
            id={`${localizationSubset}.refresh.label`}
            values={{
              timeLabel: `${dayjs(lastUpdate).format('MMM DD')} at ${dayjs(lastUpdate).format('HH:mm A')}`,
            }}
          />
        }
      >
        <Box>
          <CircularProgress
            size={28}
            variant="determinate"
            value={percentage}
            sx={{
              marginTop: '2px',
              marginLeft: '2px',
              position: 'absolute',
              color: theme.palette.divider,
              zIndex: 1,
              pointerEvents: 'none',
            }}
          />
          <ContainedIconButton
            onClick={handleClick}
            sx={(theme) => ({ width: '32px', height: '32px', color: theme.palette.primary.main })}
            aria-label="Refresh"
          >
            <FaIcon width={16} height={16} name="arrows-rotate" color={theme.palette.primary.main} />
          </ContainedIconButton>
        </Box>
      </Tooltip>
    </Stack>
  );
};
